import {GoogleAuthProvider, FacebookAuthProvider, TwitterAuthProvider} from "firebase/auth";
export const facebookProvider = new FacebookAuthProvider();
export const googleProvider = new GoogleAuthProvider();
export const twitterProvider = new TwitterAuthProvider();

